export default __webpack_public_path__ + "static/media/sound_whistle.6428650e.wav";